import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "formatContainerLabel" })
export class FormatContainerLabelPipe implements PipeTransform {
  transform(value: string | number): string {
    if (typeof value === "number") {
      value = value.toString();
    }
    if (typeof value === "string") {
      return value.replace(/(\d\d)/, "$1' ");
    }

    return "";
  }
}
